<template>
    <div class="container">
        <div class="row">
            <div class="col-sm12 col-md-12 col-lg12 text-center my-5 py-5">
                <img src="../../public/img/profile.jpg" width="100" height="100" class="rounded-circle mb-3 shadow  bg-white rounded" alt="Manas Paul">
                <h1 class="mb-2">Manas Paul</h1>
                <br>
                <div class="col-md-6 offset-md-3">
                    <p>A  <b>Full Stack Web Devloper</b> based in Kolkata, India. I worked as a freelancer for past 3 years. I will be happy to serve you the best of myself.</p>
                    
                </div>
                <div class="col-md-4 offset-md-4">
                    <ul class="nav justify-content-center">
                        <li class="nav-item">
                            <a class="nav-link active" href="https://github.com/imanaspaul"><i class="fab fa-github"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#"><i class="fab fa-twitter"></i></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="https://www.facebook.com/iammanaspaul"><i class="fab fa-facebook-square"></i></a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Hero"
}
</script>

<style scoped>
h1{
    font-weight: 500;
    letter-spacing: 5px;
}

p b{
    border-bottom: 4px solid #04d25a;
}
ul > li > a {
    color: #000;
    font-size: 20px;
}
ul > li:hover a {
    transition: 0.5s ease-in-out/;
    color: #04d25a;
    font-size: 20px;
}
</style>
